import {SubscribeFormHandler} from "@/js/handlers/SubscribeFormHandler";

SubscribeFormHandler();
